package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * The currently authenticated principal, surfaced by the auth layer and consumed by features that
 * personalize on identity (favorites, reviews, business claim, `users/{uid}` sync). Platform-agnostic
 * projection of the underlying Firebase user — never expose the SDK type past `:core:firebase`.
 *
 * [isAnonymous] distinguishes a guest (anonymous Firebase session) from a real account; a `null`
 * `AuthUser` means signed out entirely.
 */
data class AuthUser(
    val uid: String,
    val email: String?,
    val displayName: String?,
    val isAnonymous: Boolean,
)
